import { useQuery } from '@tanstack/react-query';
import { getRestaurantApi } from '../utils/apis';

export const useFetchBusiness = (tenantName: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['restaurants', tenantName],
    queryFn: () => getRestaurantApi(tenantName),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 100,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: !!tenantName,
  });

  const business = data?.data?.data[0] || null;

  return {
    business,
    isLoading,
    error,
  };
};
